<template>
   <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '预算制定')[0].value">
    <div style="margin-top: 3%;height: 90%;overflow-x: hidden;overflow-y: auto;">
      <el-form :model="budgetForm"
               ref="budgetForm"
               :rules="rules"
               label-width="250px">
               <el-form-item label="会场费用(占场地费用的30%):"
                      :required="VenueCost"
                      prop="venueCost">
          <el-input v-model="budgetForm.venueCost"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="设计费用(占场地费用的15%):"
                      :required="designCost"
                      prop="designCost">
          <el-input v-model="budgetForm.designCost"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="招商费用:"
                      :required="attractInvestment"
                      prop="attractInvestment">
          <el-input v-model="budgetForm.attractInvestment"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="媒体费用:"
                      :required="mediaCost"
                      prop="mediaCost">
          <el-input v-model="budgetForm.mediaCost"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="宣传推广费用:"
                      :required="promotionExpenses"
                      prop="promotionExpenses">
          <el-input v-model="budgetForm.promotionExpenses"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="专家费用（含差旅）:"
                      :required="expertFees"
                      prop="expertFees">
          <el-input v-model="budgetForm.expertFees"
                    :disabled="isdisabled"
                    class="inputs"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="其他费用:"
                      prop="otherCost">
          <el-input v-model="budgetForm.otherCost"
                    :disabled="isdisabled"
                    :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                    maxlength="9"
                    class="inputs">
            <template #append> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex;">
            <div v-if="BudgetList.filter((t) =>t.auditStatus ==Global.BudgetAuditState.Approved && t.state != Global.SModel.Delete).length == 0">
              <el-button type="primary" v-if="BudgetList.filter((t) =>t.state != Global.SModel.Delete).length == 0"
                       @click="determine()">
                {{BudgetList.filter((t) =>t.state != Global.SModel.Delete).length > 0? "取消": "确定"}}
              </el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  components: {
    ShowControl,
  },
  data () {
    return {
      flowID: localStorage.getItem("flowID"),
      BudgetList: [],
      isdisabled: false,
      budgetForm: {
        designCost: '',
        attractInvestment: '',
        mediaCost: '',
        promotionExpenses: '',
        expertFees: '',
        otherCost: '',
        venueCost: '',
      },
      title: '预算制定',
      rules: {
        designCost: [{ required: true, message: "请输入设计费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
        attractInvestment: [{ required: true, message: "请输入招商费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
        mediaCost: [{ required: true, message: "请输入媒体费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
        promotionExpenses: [{ required: true, message: "请输入宣传推广费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
        expertFees: [{ required: true, message: "请输入专家费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
        venueCost: [{ required: true, message: "请输入场地费用", trigger: "blur" },{ pattern: /^[0-9]*$/, message: "输入不规范" }],
      },
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      Budget: (state) => state.user.budget,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {

  },
  mounted () {
    this.GetBudgetInfo();
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/ProjectManagement")
    },
    KnowledgeClick(){
      this.$router.push({ path: '/KnowledgeControl', query: {id : this.Global.KnowledgeTypeList.filter(c=>c.name == '预算定制')[0].value}});
    },
    GetBudgetInfo () {
      this.loading = true
      this.$http.get(
        "SModel/GetTypeSModel?round=" +
        this.Round +
        "&typename=S_BudgetApplication"
      ).then((res) => {
        if (res.success) {
          this.BudgetList = res.dynamicObj
          this.BudgetList = this.BudgetList.filter(c => c.auditStatus != this.Global.BudgetAuditState.Refuse);
          if (this.BudgetList.filter(c => c.state != this.Global.SModel.Delete).length > 0) {
            this.isdisabled = true;
            this.budgetForm = this.BudgetList[0];
          } else {
            this.isdisabled = false;
          }
        }
      })
    },
    determine () {
      if (this.flowID != this.Global.FlowList.策划) {
        this.$message.error("当前流程阶段不是策划，无法进行操作！");
        return;
      }
      let that = this;
      that.$refs.budgetForm.validate((valid) => {
        if (valid) {
          let list = this.BudgetList;
          if (list.filter(c => c.state != this.Global.SModel.Delete).length > 0) {
            list[0].state = that.Global.SModel.Delete;
            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  that.Global.sendmsgmd(
                    "项目管理",
                    `取消了预算定制申请`,
                    1
                  );
                  that.GetBudgetInfo();
                  //that.budget+=1;
                  that.$store.commit("budgetCustomized", !that.Budget);
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });
          } else {
            if (list.length == 0) {
              list = [];
              list.push(that.budgetForm)
              list[0].uuid = that.uuid.guid();
              list[0].state = that.Global.SModel.Create;
            } else {
              let uuid = list[0].uuid;
              list = [];
              list.push(that.budgetForm)
              list[0].state = that.Global.SModel.Update;
              list[0].uuid = uuid;
            }
            list[0].auditStatus = that.Global.BudgetAuditState.Unaudited;
            list[0].sTTime = that.filter.formatDate(new Date());
            list[0].round = parseInt(that.Round);
            list[0].type = "S_BudgetApplication";
            that.$http
              .post("SModel/PushStrategy", that.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  that.Global.sendmsgmd(
                    "项目管理",
                    `进行预算定制申请`,
                    1
                  );
                  that.GetBudgetInfo();
                  //that.budget+=1;
                  that.$store.commit("budgetCustomized", !that.Budget);
                  that.API.createTaskBar(that.Round,that.Global.EnumUserStatus.normal,'预算定制');
                } else {
                  that.$message.error(res.message);
                  return false;
                }
              });
          }

        }
      });

    }
  },
};
  </script>

  <style scoped>
.inputs {
  width: 220px;
}
</style>